<div class="navbar">
  <div class="navbar__logo">
    <app-logo-footer
      [logoLink]="logoLink"
      [logo]="logo"
      [logoName]="logoName"
      [style.--text-color]="'#fff'"
      [style.--icon-color]="'#fff'"
    ></app-logo-footer>
    <p class="slogan desktop-slogan" *ngIf="logoSlogan">{{ logoSlogan }}</p>
  </div>
  <div class="navbar__copy-right">
    <p>{{ copyright }}</p>
  </div>
</div>
